module.exports = __webpack_public_path__ + "static/email_verification.0c900ab0.svg";